import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

const DEFAULTS = {
  title: "Mahadinusa Lembongan — Boutique Island Stay & Fast Boat Guide",
  description:
    "A quiet boutique stay in Jungutbatu, Nusa Lembongan. Garden rooms, a flowering pool, and the Sanur–Lembongan fast boat timetable. Reserve direct.",
  keywords: "Nusa Lembongan hotel, Mahadinusa, Jungutbatu accommodation, Bali island stay, Sanur Lembongan fast boat",
  og_image: "",
};

const setMeta = (attr, key, value) => {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export const Seo = () => {
  const { settings } = useSite();

  useEffect(() => {
    const seo = { ...DEFAULTS, ...(settings?.seo || {}) };
    document.title = seo.title;
    setMeta("name", "description", seo.description);
    setMeta("name", "keywords", seo.keywords);
    setMeta("property", "og:title", seo.title);
    setMeta("property", "og:description", seo.description);
    setMeta("name", "twitter:title", seo.title);
    setMeta("name", "twitter:description", seo.description);
    if (seo.og_image) {
      setMeta("property", "og:image", seo.og_image.startsWith("/") ? `${window.location.origin}${seo.og_image}` : seo.og_image);
      setMeta("name", "twitter:image", seo.og_image.startsWith("/") ? `${window.location.origin}${seo.og_image}` : seo.og_image);
    }
  }, [settings]);

  return null;
};
